export const setMap = map => ({
  type: 'SET_MAP',
  payload: map,
});
